export default {
  data: {
    id: "",
    validityPeriod:"",
    teststatus: "",
    cancelstatue: "",
    expirestatus: ""
  },
  //type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
  rule: {
    id: {
      type: "id",
      message: "审核参数丢失请刷新浏览器重新尝试",
    },
    validityPeriod: {
      type: "Empty",
      message: "请选择年审起止时间",
    },
    teststatus: {
      type: "id",
      message: "请选择船舶检验状态",
    },
    cancelstatue: {
      type: "id",
      message: "请选择船舶注销状态",
    },
    expirestatus: {
      type: "id",
      message: "请选择船舶过期状态",
    },
  },
};
